module.exports = __webpack_public_path__ + "img/join-bg (1).f43e407a.jpg";